export const clampString = (s: string, charCount: number): string => {
  if (s.length <= charCount) return s;
  return s.slice(0, charCount) + "...";
};
